/* eslint-disable react-hooks/refs */
import React, {useContext, useMemo, useRef} from 'react';
import {cn} from '@features/ui/utils';
import {useFlowThemeProperties} from '@features/flow/flowHook';
import type {GenType} from '@features/flow/flowService';
import {fixHtmlInClient} from '../fixHtmlUtil';
import {ShadowDivWithForwardEvents} from './ShadowDivWithForwardEvents';
import {getFrameInnerStyles} from './frameInnerStyles';
import {getFrameStyles} from './getFrameStyles';
import {FlowContext} from '@features/contexts/FlowContext';

type Props = {
  structureString: string;
  flowId: string;
  genType: GenType;
  screenId: string;
};

export const StreamingWebHtmlCssFrame = ({
  structureString,
  flowId,
  genType,
  screenId,
}: Props) => {
  const isComponents = useContext(FlowContext).flow.genType === 'components';
  const lastValidStructure = useRef<string>(undefined);
  const themeProperties = useFlowThemeProperties(flowId, screenId);

  const htmlContent = useMemo(() => {
    try {
      if (!structureString.trim()) return lastValidStructure.current;

      const structure = fixHtmlInClient(structureString);

      lastValidStructure.current = structure;
      return structure;
      // We deliberetely ignore errors but can't omit the paramter
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
      return lastValidStructure.current;
    }
  }, [structureString]);
  if (!htmlContent) return null;

  return (
    <ShadowDivWithForwardEvents
      className={cn(
        'relative flex min-h-[812px] bg-background',
        genType === 'mobile-html-css' && 'w-[375px]',
        genType === 'web-html-css' && 'w-[1440px]',
      )}
      data-banani-screenid={screenId}
    >
      <div
        style={getFrameStyles(themeProperties)}
        dangerouslySetInnerHTML={{__html: htmlContent}}
        data-banani-screenid={screenId}
      />
      <style children={getFrameInnerStyles(isComponents)} />
    </ShadowDivWithForwardEvents>
  );
};
